import axios, { AxiosResponse } from 'axios';
import { Tool } from '../materials/tools';
import { apiClient } from '../apiClient';

export interface DailyTool {
    _id: string;
    toolId: Tool;
    activityId: string;
    state: number;
    isUsed: boolean;
    price?: number;
    priceType?: number;
    quantity: number;
    unitPrice?: number;
}

export interface DeleteDailyToolResponse {
    message: string;
    data: DailyTool;
}
export interface DeleteDailyToolQueries {
    deleteTransfers?: boolean;
}

export const deleteDailyTool = async (id: string, queries?: DeleteDailyToolQueries): Promise<DeleteDailyToolResponse> => {
    try {
        const response: AxiosResponse<DeleteDailyToolResponse> = await apiClient.delete(`/daily-tools/${id}`, { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

interface CreateDailyToolResponse {
    message: string;
    data: DailyTool;
}

export const createDailyTool = async (
    activityId: string,
    toolId: string,
    state: number,
    createTransfer?: boolean,
    price?: number | null,
    priceType?: number | null,
    quantity?: number
): Promise<CreateDailyToolResponse> => {
    try {
        const response: AxiosResponse<CreateDailyToolResponse> = await apiClient.post('/daily-tools', {
            activityId,
            toolId,
            state,
            createTransfer,
            price,
            priceType,
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DailyToolResponse {
    message: string;
    data: DailyTool;
}

export interface UpdateDailyToolBody {
    activityId?: string;
    toolId?: string;
    state?: number;
    createTransfer?: boolean;
    isUsed?: boolean;
    price?: number | null;
    priceType?: number | null;
    quantity?: number;
    unitPrice?: number | null;
}

export interface UpdateDailyToolQueries {
    deleteTransfers?: boolean;
    syncTransfers?: boolean;
}

export const updateDailyTool = async (id: string, body: UpdateDailyToolBody, queries?: UpdateDailyToolQueries): Promise<DailyToolResponse> => {
    try {
        const response: AxiosResponse<DailyToolResponse> = await apiClient.patch('/daily-tools/' + id, body, { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
